//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'DIA',
  data() {
    return {
      form: {
        check: '',
        item1: '',
        item2: ''
      },
      checkList: [
        { value: '1', name: '否' },
        { value: '2', name: '是' },
      ],
      item1List: [
        { value: '1', name: '每天排便增加<4次' },
        { value: '2', name: '每天排便增加4~6次，工具性日常生活活动受限' },
        { value: '3', name: '每天排便增加27次，需住院；自我照顾日常生活受限' },
        { value: '4', name: '危及生命，需紧急干预' },
      ],
      item2List: [
        { value: '1', name: '造口处排泄量轻度增加' },
        { value: '2', name: '造口处排泄量中度增加；工具性日常生活活动受限' },
        { value: '3', name: '造口处排泄量重度增加；自我照顾日常生活活动受限；需住院' },
        { value: '4', name: '危及生命，需紧急干预' },
      ],
      hasScore: false,
      disabled: false,
      text: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result
      if (form.check == 1) {
        result = form.item1
      } else if (form.check == 2) {
        result = form.item2
      } else {
        result = ''
      }
      if (result == 1) {
        self.text = '轻度腹泻'
      } else if (result == 2) {
        self.text = '中度腹泻'
      } else if (result == 3) {
        self.text = '重度腹泻；应及时按说明书调整剂量或停药，给予治疗'
      } else if (result == 4) {
        self.text = '危及生命，需要急干预，按说明书调整剂量或停药，给予治疗'
      }
      console.log(result);
      self.hasScore = true
      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/DIA.vue